import { Injectable } from '@angular/core';

export const Keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESCAPE: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  INSERT: 45,
  DELETE: 46,
  KEY_0: 48,
  KEY_1: 49,
  KEY_2: 50,
  KEY_3: 51,
  KEY_4: 52,
  KEY_5: 53,
  KEY_6: 54,
  KEY_7: 55,
  KEY_8: 56,
  KEY_9: 57,
  KEY_A: 65,
  KEY_B: 66,
  KEY_C: 67,
  KEY_D: 68,
  KEY_E: 69,
  KEY_F: 70,
  KEY_G: 71,
  KEY_H: 72,
  KEY_I: 73,
  KEY_J: 74,
  KEY_K: 75,
  KEY_L: 76,
  KEY_M: 77,
  KEY_N: 78,
  KEY_O: 79,
  KEY_P: 80,
  KEY_Q: 81,
  KEY_R: 82,
  KEY_S: 83,
  KEY_T: 84,
  KEY_U: 85,
  KEY_V: 86,
  KEY_W: 87,
  KEY_X: 88,
  KEY_Y: 89,
  KEY_Z: 90,
  LEFT_META: 91,
  RIGHT_META: 92,
  SELECT: 93,
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105,
  MULTIPLY: 106,
  ADD: 107,
  SUBTRACT: 109,
  DECIMAL_POINT: 110,
  DIVIDE: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145,
  SEMICOLON: 186,
  EQUALS: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,
  FORWARD_SLASH: 191,
  GRAVE_ACCENT: 192,
  OPEN_BRACKET: 219,
  BACK_SLASH: 220,
  CLOSE_BRACKET: 221,
  SINGLE_QUOTE: 222
};

@Injectable()
export class KeycodeService {
  
  


constructor() { }

isDateKey(evt) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode >= Keys.SPACE && (charCode < Keys.KEY_0 || charCode > Keys.KEY_9)) {
      if (!(charCode >= Keys.NUMPAD_0 && charCode <= Keys.NUMPAD_9) && (charCode !== Keys.SUBTRACT) && (charCode !== Keys.DASH)) {
        return false;
      }
    }
    return true;
  }

  isNumberKey(evt) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode >= Keys.SPACE && (charCode < Keys.KEY_0 || charCode > Keys.KEY_9)) {
      if (!(charCode >= Keys.NUMPAD_0 && charCode <= Keys.NUMPAD_9)) {
        return false;
      }
    }
    return true;
  }

  isDeleteKey(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode === Keys.DELETE
      || charCode === Keys.BACKSPACE) {
        return true;
      }
    return false;
  }

  isMoveKey(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode === Keys.UP_ARROW
        || charCode === Keys.DOWN_ARROW
        || charCode === Keys.LEFT_ARROW
        || charCode === Keys.RIGHT_ARROW
        || charCode === Keys.TAB
        || charCode === Keys.HOME
        || charCode === Keys.END) {
      return true;
    }
    return false;
  }

  isPhoneNumberCheck(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    // if ((charCode === Keys.ADD || (evt.shiftKey && charCode === Keys.EQUALS))
    //     && evt.target instanceof HTMLInputElement
    //     && (<HTMLInputElement>evt.target).value !== '') {
    //   return false;
    // }

    return this.isTxnNumberKey(evt) ||
      charCode === Keys.ADD ||
      (evt.shiftKey && charCode === Keys.EQUALS);
  }

  isTxnNumberKey(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    return (this.isDeleteKey(evt) ||
      this.isMoveKey(evt) ||
      charCode === Keys.ENTER ||
      charCode === Keys.DECIMAL_POINT ||
      charCode === Keys.PERIOD ||
      charCode === Keys.SUBTRACT ||
      // Only Number not special character
      (evt.shiftKey === false && (charCode >= Keys.KEY_0 && charCode <= Keys.KEY_9)) ||
      (charCode >= Keys.NUMPAD_0 && charCode <= Keys.NUMPAD_9));
  }

  isMultiTxnNumber(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    return (
      (charCode >= Keys.KEY_A && charCode <= Keys.KEY_Z) ||
      this.isDeleteKey(evt) ||
      this.isMoveKey(evt) ||
      charCode === Keys.COMMA ||
      charCode === Keys.SPACE ||
      (evt.ctrlKey === true && charCode === Keys.KEY_A) ||
      (evt.shiftKey === false && (charCode >= Keys.KEY_0 && charCode <= Keys.KEY_9)) ||
      (charCode >= Keys.NUMPAD_0 && charCode <= Keys.NUMPAD_9)
    );
  }

  isNumberKeyOld(evt: KeyboardEvent) {
    if (evt.shiftKey) {
      return false;
    }
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    return (charCode === 8 ||
      charCode === 9 ||
      charCode === 13 ||
      charCode === 110 ||
      charCode === 190 ||
      (charCode >= 35 && charCode <= 40) ||
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 96 && charCode <= 105));
  }

  constrainUserInput(id) {
    let input = <HTMLInputElement>document.getElementById(id);
    let value = input.value;
    if (value.length > input.maxLength) {
      input.value = value.substring(0, input.maxLength);
    }
  }

  isDecimalNumber(evt: KeyboardEvent) {
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == Keys.DECIMAL_POINT || this.isNumberKey(evt)) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/keycode.service.ts